import { useQuery } from "@tanstack/react-query";
import { fetcher } from "@/lib/api";
import Seo from "@/components/Seo";
import Hero from "@/components/home/Hero";
import RecentWork from "@/components/home/RecentWork";
import Strengths from "@/components/home/Strengths";
import Services from "@/components/home/Services";
import Skills from "@/components/home/Skills";
import Testimonials from "@/components/home/Testimonials";
import ContactCTA from "@/components/home/ContactCTA";

export default function Home() {
  const { data: site } = useQuery({ queryKey: ["site"], queryFn: () => fetcher("/site") });
  const { data: studies } = useQuery({ queryKey: ["case-studies"], queryFn: () => fetcher("/case-studies") });

  const personLd = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: "Nishant Gathwal",
    jobTitle: "UX Designer",
    description:
      "UX designer with 8+ years designing product experiences across travel, edtech, and HR & enterprise software.",
    address: { "@type": "PostalAddress", addressLocality: "New Delhi", addressCountry: "IN" },
    sameAs: ["https://www.linkedin.com/in/nishant-gathwal-8494b047/"],
    alumniOf: ["IIT Hyderabad", "Netaji Subhas Institute of Technology"],
    knowsAbout: ["UX Design", "Product Design", "User Research", "Travel Apps", "Edtech", "HR Software"],
  };

  return (
    <div data-testid="home-page">
      <Seo
        title="UX Designer in New Delhi"
        description="Nishant Gathwal — UX designer with 8+ years crafting product experiences across travel, edtech, and HR & enterprise software. See selected case studies from Ixigo, TheGeeksLab, and HROne."
        path="/"
        jsonLd={personLd}
      />
      <Hero profile={site?.profile} />
      <RecentWork studies={studies || []} />
      <Strengths strengths={site?.strengths || []} />
      <Services services={site?.services || []} />
      <Skills skills={site?.skills || []} />
      <Testimonials testimonials={site?.testimonials || []} />
      <ContactCTA />
    </div>
  );
}
